import { Form, Grid, Message } from '@arco-design/web-react';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { useStoreValues } from "../../../Components/GlobalContext/GlobalStateProvider";
import {
  allowAlphanumericAndSpecialChars,
  cleanAlphabetsOnly,
  getLocalStorage,
  handleApiError,
  removeLeadingSpace,
  removeSpaces,
  sanitizeEmail,
  sanitizePhoneNumber,
  setLocalStorage,
} from '../../../common/Utils/Utils';
import { ManageApis } from '../../../common/APIS/ManageApis';
import InputField from '../../InputField/InputField';
import { useAlert } from '../../../common/Context/AlertContext';
import { RegisterFormField } from './RegisterFormField';
import { useLoader } from '../../../common/Context/LoaderContext';
import {
  HARDCODED_PLAN_ID,
  HARDCODED_PRODUCT_ID,
  MAINTENANCE_MESSAGES,
  PRODUCT_PLATFORM,
} from '../../../common/constant';
import SubmitButton from '../../submitButton/SubmitButton';
import notify from '../../../common/Utils/toastService';
import { FEATURE_FLAGS } from '../../../common/config/featureFlags';
const FormItem = Form.Item;

function RegisterForm() {
  // const { planDetails, setPlanDetails } = useStoreValues();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryCode, setCountryCode] = useState('+91'); // Default country code for India
  const location = useLocation();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const formRef = useRef();
  // const { product, plan } = location.state || {}; // Retrieve product and plan from state
  const [form] = Form.useForm();
  // const product = planDetails?.productId;
  // const plan = planDetails?.selectedPlanId;
  // const isCustom = planDetails?.isCustom;

  const handleInputChange = (value, field) => {
    const valueWithoutLeadingSpace = removeLeadingSpace(value);

    switch (field) {
      case 'firstName':
        const sanitizedNameValue = cleanAlphabetsOnly(valueWithoutLeadingSpace);
        if (field === 'firstName') {
          // Only capitalize the very first character, keep everything else as user typed
          const capitalizedFirstName =
            sanitizedNameValue.charAt(0).toUpperCase() +
            sanitizedNameValue.slice(1);
          form.setFieldValue(field, capitalizedFirstName);
        } else {
          form.setFieldValue(field, sanitizedNameValue);
        }
        break;

      case 'company':
        const sanitizedCompanyValue = allowAlphanumericAndSpecialChars(
          valueWithoutLeadingSpace
        );
        form.setFieldValue(field, sanitizedCompanyValue);
        break;
      case 'phoneNumber':
        const sanitizedMobileNumber = sanitizePhoneNumber(
          valueWithoutLeadingSpace
        );
        form.setFieldValue(field, sanitizedMobileNumber);
        break;
      case 'password':
      case 'confirmPassword':
        const sanitizedPassword = removeSpaces(value);
        form.setFieldValue(field, sanitizedPassword);
        break;
      case 'email':
        const sanitizedEmailValue = sanitizeEmail(valueWithoutLeadingSpace);
        form.setFieldValue(field, sanitizedEmailValue);
        break;

      default:
        form.setFieldValue(field, valueWithoutLeadingSpace);
        break;
    }
  };

  const handleSubmit = async () => {
    if (
      FEATURE_FLAGS.APPLICATION_UNDER_MAINTENANCE &&
      FEATURE_FLAGS.BLOCK_REGISTRATION_DURING_MAINTENANCE
    ) {
      notify.error(MAINTENANCE_MESSAGES.UNREGISTERED_USER);
      return;
    }
    try {
      const isValid = await form.validate();
      if (!isValid) {
        console.log('Validation failed. Please check the form.');
        return;
      }
      const fields = form.getFieldsValue();
      console.log('Fields:', fields);
      const phoneNumber = fields?.phoneNumber;
      const phoneNumberAsString = phoneNumber ? String(phoneNumber) : undefined;
      const { phoneNumber: _, confirmPassword: __, ...otherFields } = fields;

      // Get UTM data from localStorage
      const utmData = getLocalStorage('utm_data');
      const parsedUtmData = utmData || {};

      const reqBody = {
        ...otherFields,
        // product,
        product: HARDCODED_PRODUCT_ID,
        plan: HARDCODED_PLAN_ID,
        // isCustom,
        // plan,
        platform: PRODUCT_PLATFORM.PCS_PLATFORM,
        phoneNumber: phoneNumberAsString,
        countryCode: countryCode, // Send country code separately
        // Only add UTM fields if they have values
        ...(parsedUtmData.utm_source && {
          utm_source: parsedUtmData.utm_source,
        }),
        ...(parsedUtmData.source_page && {
          source_page: parsedUtmData.source_page,
        }),
        // ...(parsedUtmData.utm_medium && {
        //   utm_medium: parsedUtmData.utm_medium,
        // }),
        // ...(parsedUtmData.utm_campaign && {
        //   utm_campaign: parsedUtmData.utm_campaign,
        // }),
      };
      setIsSubmitting(true);
      const response = await ManageApis(
        'post',
        window.registration,
        reqBody,
        ''
      );
      const { status_code, message } = response || {};
      const {
        status,
        onBoardingStage,
        emailConfirmationRequired,
        userId,
        accountId,
        message: responseMessage = '',
        redirectToLogin,
      } = response?.response_data || {};
      const { existingPlanDetails, newPlanDetails, productId } =
        response?.response_data?.data || {};
      if (status_code === 200 && message === 'Success') {
        setLocalStorage('accountid', accountId);
        setLocalStorage('id', userId);
        if (onBoardingStage == 1) {
          if (redirectToLogin !== true) {
            setLocalStorage('responseMessage', response?.response_data);
            notify.success(responseMessage);
            navigate(`/verify-email`, { state: { emailId: fields?.email } });
          }
        } else if (onBoardingStage === 2) {
          if (redirectToLogin == true) {
            notify.info(responseMessage);
            navigate('/login');
          }
        } else if (redirectToLogin === true) {
          notify.success(responseMessage);
          navigate('/login');
        } else if (redirectToLogin === false) {
          notify.success(responseMessage);
          navigate('/verify-email', { state: { emailId: fields?.email } });
        } else if (status === 'Failed') {
          handleApiError(status, responseMessage, status_code, showAlert);
        } else {
          handleApiError(status, message, status_code, showAlert);
        }
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="w-100">
        <div className=" p-md-0 ms-lg-4">
          <h3 className="font_30 fw_600">Registration</h3>
          <p className="font_12 font_500 text_gray10 mb-4">
            Get started by Registering now
          </p>
          <div className="customForm">
            {FEATURE_FLAGS.APPLICATION_UNDER_MAINTENANCE && (
              <div className="br_5 d-flex gap-2 mb-2 p-2 text-bg-danger text-bg-warning font_13">
                <span>⚠️</span>
                <span>{MAINTENANCE_MESSAGES.UNREGISTERED_USER}</span>
              </div>
            )}
            <Form
              form={form}
              ref={formRef}
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <div className="customInput">
                <Grid.Row gutter={12}>
                  {RegisterFormField(form, false, countryCode).map((field) => (
                    <InputField
                      inputStyle={{ height: '42px' }}
                      key={field.field}
                      value={form.getFieldValue(field.field)}
                      onChange={(value) =>
                        handleInputChange(value, field.field)
                      } // Use custom onChange handler
                      countryCode={countryCode}
                      onCountryChange={setCountryCode}
                      {...field}
                    />
                  ))}
                </Grid.Row>
              </div>
              <div className="position-relative d-flex">
                <SubmitButton
                  onClick={handleSubmit}
                  isLoading={isSubmitting}
                  className="mt-3 rounded-pill"
                  label="Register"
                />
              </div>
              <div className="text_gray10 mt-3 pt-2 position-relative position_center ">
                Already have an account? <Link to={`/login`}> Login</Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterForm;
